export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";